import React from 'react';
import cn from 'classnames';

import styles from './Input.module.scss';

const Input = ({
  className,
  fieldClassName,
  endAdornmentClassName,
  startAdornmentClassName,
  disabled,
  multiline,
  haveError,
  inputRef,
  value,
  startAdornment,
  endAdornment,
  ...restProps
}: {
  className: any;
  fieldClassName: any;
  endAdornmentClassName: any;
  startAdornmentClassName: any;
  disabled: any;
  multiline: any;
  haveError: any;
  inputRef: any;
  value: any;
  startAdornment: any;
  endAdornment: any;
} & Record<string, any>) => {
  const Component = multiline ? 'textarea' : 'input';

  return (
    <div
      className={cn(
        styles.input,
        { [styles.inputDisabled]: disabled },
        className,
      )}
    >
      {startAdornment && (
        <div className={cn(styles.startAdornment, startAdornmentClassName)}>
          {startAdornment}
        </div>
      )}
      <Component
        {...restProps}
        ref={inputRef}
        className={cn(
          styles.field,
          {
            [styles.fieldHaveValue]: !!value,
            [styles.fieldHaveError]: haveError,
            [styles.fieldMultiline]: multiline,
            [styles.fieldWithStartAdornment]: !!startAdornment,
            [styles.fieldWithEndAdornment]: !!endAdornment,
          },
          fieldClassName,
        )}
        value={value}
      />
      {endAdornment && (
        <div className={cn(styles.endAdornment, endAdornmentClassName)}>
          {endAdornment}
        </div>
      )}
    </div>
  );
};

export default React.memo(Input) as any;
